import { render, staticRenderFns } from "./PlaceList.vue?vue&type=template&id=5b872fc0&scoped=true&"
import script from "./PlaceList.vue?vue&type=script&lang=js&"
export * from "./PlaceList.vue?vue&type=script&lang=js&"
import style0 from "./PlaceList.vue?vue&type=style&index=0&id=5b872fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b872fc0",
  null
  
)

export default component.exports